import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { ErrorMessage, Formik } from 'formik';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import BasicInputFile from '../../../../components/BasicInputFile';
import LoadMask from '../../../../components/LoadMask';
import {ANIMATION_TIMEOUT_APPEAR} from '../../../../constants/animation';
import ENDPOINT from '../../../../constants/endpoints';
import useApi from '../../../../hooks/useApi';
import UploadResumeFormValidationSchema from './validate';

const UploadResumeForm = props => {
  const {
    actions: { proceed, cancel, dismiss, handleError },
    params,
  } = props;

  const api = useApi();

  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    const selfEdit = !params || !params.id;

    const endpoint = selfEdit
      ? ENDPOINT.ACTION.UPLOAD_RESUME
      : ENDPOINT.ACTION.EDIT_CANDIDATE_PROFILE_UPLOAD_RESUME;

    const queryParams = selfEdit
      ? { resume: values.Resume }
      : { resume: values.Resume, id: params.id };

    api.post(endpoint, queryParams, {
      handleError: response => {
        setSubmitting(false);
        handleError(response, setErrors);
      },
      handleSuccess: response => proceed(response),
    });
  };

  const removeResume = (field, setFieldValue) => {
    setFieldValue(field, null);
  };

  const selectResume = (e, setFieldValue, setFieldTouched) => {
    const {
      target: { files, name },
    } = e;
    const [file = null] = files;

    if (file) {
      setFieldValue(name, file);
      setFieldTouched(name, true, true);
    }
  };

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div>
        <Formik
          initialValues={{ Resume: null }}
          validationSchema={UploadResumeFormValidationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
          }) => (
            <form
              onSubmit={handleSubmit}
              className="form__content"
              style={{ maxWidth: '100%' }}
            >
              {isSubmitting && <LoadMask />}

              {params && params.message && (
                <div className="dialog__message">{params.message}</div>
              )}

              <BasicInputFile
                inputStyles={{ marginLeft: 0 }}
                file={values.Resume}
                fieldName="Resume"
                onRemoveHandler={field => removeResume(field, setFieldValue)}
                onChangeHandler={e =>
                  selectResume(e, setFieldValue, setFieldTouched)
                }
                accept=".doc,.docx,.pdf,.odt,.rtf"
                disclaimer="(*doc, *docx, *pdf, *odt, *rtf)"
              />
              <ErrorMessage
                name="Resume"
                render={message => <div className="form__error">{message}</div>}
              />

              <div className="form__controls form__controls--compact">
                <BasicButtonGroup
                  groupStyles={{
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <BasicButton
                    disabled={!values.Resume || !!errors.Resume}
                    controlFunc={handleSubmit}
                    btnWidth={200}
                    btnHeight={35}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={false}
                    btnText={'Send Resume'}
                  />
                  <BasicButton
                    controlFunc={params.dismissWhenClose ? dismiss : cancel}
                    btnWidth={200}
                    btnHeight={35}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText={'Cancel'}
                  />
                </BasicButtonGroup>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  );
};

export default UploadResumeForm;
